import React from 'react';
import { Box } from '@mui/material';
import { MuiSpinner } from '@ace/ace-ui-web';

interface LoadingOverlayProps {
  /** Controls visibility of the overlay */
  isLoading: boolean;
  /** Background color with opacity. Defaults to semi-transparent white */
  backgroundColor?: string;
  /** Z-index for overlay positioning. Defaults to 9999 */
  zIndex?: number;
  /** Spinner color variant */
  spinnerColor?: 'primary' | 'secondary';
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isLoading,
  backgroundColor = 'rgba(255, 255, 255, 0.8)',
  zIndex = 9999,
  spinnerColor = 'secondary',
}) => {
  if (!isLoading) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex,
      }}>
      <MuiSpinner color={spinnerColor} />
    </Box>
  );
};

export default LoadingOverlay;
